module.exports = "<gw-locations-and-buildings initial-page=\"bopLocationsAndBuildings\"/>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/quoteandbind/ama/cpp/views/cpp-locations-and-buildings.html
// module id = 472
// module chunks = 0